import { any, shape, string } from 'prop-types';
import React from 'react';
import { components } from 'react-select';

import Typography from 'ravenjs/lib/Typography';

import { DEFAULT_COLORS } from 'constants/colors';

const ValueContainer = props => {
    const {
        children,
        selectProps: { value, hideSelectedCount },
    } = props;
    const selectedOptionsCount = Array.isArray(value) ? value.length : 0;

    return (
        <components.ValueContainer {...props}>
            {Boolean(selectedOptionsCount) && !hideSelectedCount && (
                <Typography
                    type="documentFilter"
                    backgroundColor={DEFAULT_COLORS.LIGHTEST}
                    padding="2px 5px"
                >
                    {`${selectedOptionsCount} selected`}
                </Typography>
            )}
            {children}
        </components.ValueContainer>
    );
};

ValueContainer.propTypes = {
    children: any.isRequired,
    selectProps: shape({
        placeholder: string.isRequired,
    }).isRequired,
};

export default ValueContainer;
